var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItineraryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.7349L10 21.2104L15.625 15.6404M10 10.0703V6.60449C10 5.21804 10 4.5248 10.2725 3.99525C10.5122 3.52943 10.8946 3.15072 11.365 2.91338C11.8998 2.64355 12.5999 2.64355 14 2.64355H23.5C24.9001 2.64355 25.6003 2.64355 26.135 2.91338C26.6054 3.15072 26.9879 3.52943 27.2275 3.99525C27.5 4.5248 27.5 5.21804 27.5 6.60449V16.0117C27.5 17.3982 27.5 18.0915 27.2275 18.621C26.9879 19.0868 26.6054 19.4655 26.135 19.7028C25.6003 19.9727 24.9001 19.9727 23.5 19.9727H20M6.5 27.3994H16C17.4001 27.3994 18.1002 27.3994 18.635 27.1296C19.1054 26.8923 19.4879 26.5135 19.7275 26.0477C20 25.5182 20 24.8249 20 23.4385V14.0312C20 12.6448 20 11.9516 19.7275 11.422C19.4879 10.9562 19.1054 10.5775 18.635 10.3401C18.1002 10.0703 17.4001 10.0703 16 10.0703H6.5C5.09987 10.0703 4.3998 10.0703 3.86503 10.3401C3.39461 10.5775 3.01216 10.9562 2.77249 11.422C2.5 11.9516 2.5 12.6448 2.5 14.0312V23.4385C2.5 24.8249 2.5 25.5182 2.77249 26.0477C3.01216 26.5135 3.39461 26.8923 3.86503 27.1296C4.3998 27.3994 5.09986 27.3994 6.5 27.3994Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItineraryIcon);
export default __webpack_public_path__ + "static/media/Itinerary-icon.a05703abec93c45ecb1660b4afc797fc.svg";
export { ForwardRef as ReactComponent };